import { DataService } from '../../utils/dataService'
import { AxiosResponse } from 'axios'
import { message, error} from '../../notifications/displayMessage'
import { datadogLogs } from '@datadog/browser-logs'
import config from '../../config/enviroment'
import { language } from '../../utils/language'

export const LOADING_PURCHASE = 'LOADING_PURCHASE'
export const ADD_PURCHASE_PRODUCTS = 'ADD_PURCHASE_PRODUCTS'

export const handleFetchPurchase = (purchaseId: number, path:string, location: Location, history: any, defaultLanguage: string) => async (dispatch: any) => {

    const _dataService = new DataService()

    if (purchaseId) {
        const data = {
            url: path,
            id: purchaseId,
            origin: config.landingIdentifier
        }
        dispatch({ type: LOADING_PURCHASE })
        await _dataService
            .post('/catalogue/shoppingcart/find', data)
            .then((res: AxiosResponse) => {
                if (res.status === 200 && res.data.success === true) {
                    const purchaseData = res.data.data || {};
                    const purchaseState = purchaseData.state ?? purchaseData.estado;
                    const contactName =
                        purchaseData.contactName ??
                        purchaseData.nombre_contacto ??
                        purchaseData.envio?.nombre ??
                        '';
                    const guideId =
                        purchaseData.guideId ??
                        purchaseData.guiaId ??
                        purchaseData.guide?.aveonline?.data?.guia ??
                        null;
                    const deliveryCarrierFromResponse =
                        purchaseData.carrier ??
                        purchaseData.envio?.carrier;
                    const deliveryCarrier =
                        deliveryCarrierFromResponse ??
                        (
                            purchaseData.deliveryCarrierName ||
                            purchaseData.deliveryDaysDelivery ||
                            purchaseData.deliveryCarrierAmount
                        ? {
                            nameCarrier: purchaseData.deliveryCarrierName ?? '',
                            daysDelivery: purchaseData.deliveryDaysDelivery ?? '',
                            deliveryAmount: purchaseData.deliveryCarrierAmount ?? 0,
                        }
                        : null);
                    const catalogueNameFromPath = history?.location?.pathname?.split('/')[2] ?? null;

                    if (purchaseState === 'eliminado' || (purchaseState === 'activo' && contactName === '')) {
                        return history.push('/')
                    }
                    dispatch({
                        type: ADD_PURCHASE_PRODUCTS,
                        payload: {
                            id: purchaseData.id,
                            total: purchaseData.total,
                            consumptionTaxAmountTotal:
                                purchaseData.consumptionTaxAmountTotal ??
                                purchaseData.total_detallado?.consumptionTaxAmount ??
                                0,
                            taxAmountTotal:
                                purchaseData.taxAmountTotal ??
                                purchaseData.total_detallado?.taxAmount ??
                                0,
                            products: purchaseData.products ?? purchaseData.productos ?? [],
                            quantity: purchaseData.quantity ?? purchaseData.cantidad ?? 0,
                            state: purchaseState,
                            date: purchaseData.date ?? purchaseData.fecha,
                            clientId: purchaseData.clientId ?? purchaseData.clienteId,
                            publicKey: purchaseData.publicKey,
                            address: purchaseData.address ?? purchaseData.envio?.direccion ?? '',
                            contactName: contactName,
                            contactPhone:
                                purchaseData.contactPhone ??
                                purchaseData.numero_contacto ??
                                String(purchaseData.envio?.telefono ?? ''),
                            email:
                                purchaseData.email ??
                                purchaseData.contactEmail ??
                                purchaseData.envio?.correo ??
                                '',
                            city: purchaseData.city ?? purchaseData.envio?.ciudad ?? '',
                            codeDane:
                                purchaseData.codeDane ??
                                purchaseData.envio?.codigo_dane ??
                                '',
                            shipping: purchaseData.quote ?? purchaseData.shipping ?? {},
                            invoice: purchaseData.invoice ?? {},
                            discountAmount:
                                purchaseData.discountAmount ??
                                purchaseData.total_descuentos ??
                                0,
                            detailTotal:
                                purchaseData.detailTotal ??
                                purchaseData.total_detallado ??
                                {},
                            shippingCost:
                                purchaseData.shippingCost ??
                                purchaseData.valor_envio ??
                                purchaseData.envio?.valor_envio ??
                                0,
                            guide: purchaseData.guide ?? null,
                            guideId: guideId,
                            trackingInternalUrl:
                                purchaseData.trackingInternalUrl ??
                                (purchaseData.id && catalogueNameFromPath
                                    ? `/vende/${catalogueNameFromPath}/guide/${encodeURIComponent(
                                          String(purchaseData.id),
                                      )}`
                                    : null),
                            carrier: deliveryCarrier,
                            stateDelivery:
                                purchaseData.stateDelivery ??
                                purchaseData.estado_entrega ??
                                '',
                            isAveonline:
                                purchaseData.shipping?.es_aveonline ??
                                purchaseData.envio?.es_aveonline ??
                                false,
                        }
                    })
                    
                } else {
                    if (res.data.titleResponse === 'shopping cart abandoned or deleted') {

                        message(language[defaultLanguage]["shoppingDelete"])
                        history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
                    } else {
                        message(`${language[defaultLanguage]["error"]}.`)
                        history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
                    }
                }
            })
            .catch((err) => {
                error(`${language[defaultLanguage]["error"]}.`)
                datadogLogs.logger.info('error request handleFetchPurchase', { name: 'post /catalogue/shoppingcart/find', body: data, error: err.message })
                history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
            })
    } else {
        history.push(location.pathname.substring(0, location.pathname.indexOf('carrito')))
        error(language[defaultLanguage]["error"])
    }
}
